import React, { useContext, useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { UserContext } from "../context/user-context";

import useScrollTrigger from "../hooks/scroll-trigger";
import { Container, Fade, Grid } from "@mui/material";
import ThemeCard from "../components/card/theme-card";
import "../custom.d.ts";
import "./style.scss";
import Banner from "../components/banner/banner";
import ContactForm from "../components/form/contact-form";
import { BSGAPI } from "../auth/bsg-api";
import { ContextService } from "../context/context-service";
import { DWebContent } from "../model";
import Loading from "../components/loading/loading";
import IconCard from "../components/card/icon-card";
import MoreIcon from "@mui/icons-material/More";
import AdminPanelSettingsIcon from "@mui/icons-material/AdminPanelSettings";
import NextWeekIcon from "@mui/icons-material/NextWeek";
import BubbleChartOutlinedIcon from "@mui/icons-material/BubbleChartOutlined";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import DeveloperModeIcon from "@mui/icons-material/DeveloperMode";
import EmojiSymbolsOutlinedIcon from "@mui/icons-material/EmojiSymbolsOutlined";
import GroupAddOutlinedIcon from "@mui/icons-material/GroupAddOutlined";
import CloudDoneIcon from "@mui/icons-material/CloudDone";
import CompareArrowsIcon from "@mui/icons-material/CompareArrows";
import ShareLocationIcon from "@mui/icons-material/ShareLocation";
import AssistantDirectionIcon from "@mui/icons-material/AssistantDirection";
import SlowMotionVideoIcon from "@mui/icons-material/SlowMotionVideo";
import NotificationsActiveIcon from "@mui/icons-material/NotificationsActive";
import InsightsIcon from "@mui/icons-material/Insights";
import TouchAppIcon from "@mui/icons-material/TouchApp";
import UMap from "../ubq/u-map";
import YouTubeCard from "../components/card/youtube-card";

const HowWork = (props: any) => {
  //const { children, window } = props;
  const { t, i18n } = useTranslation("content");

  const context = useContext(UserContext);

  const [webContent, setWebContent] = useState({} as DWebContent);

  const myRefVideo = useRef<HTMLDivElement>(null);
  const myRefPosition = useRef<HTMLDivElement>(null);

  const getTrigger = useScrollTrigger();

  const [triggerVideo, settriggerVideo] = useState(
    getTrigger(myRefVideo.current).trigger
  );
  const [triggerPosition, setTriggerPosition] = useState(
    getTrigger(myRefPosition.current).trigger
  );
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    window.onscroll = () => {
      settriggerVideo(getTrigger(myRefVideo.current).trigger);
      setTriggerPosition(getTrigger(myRefPosition.current).trigger);
    };

    BSGAPI.getWebContent("how-it-works").then((json) => {
      let webContent = json as DWebContent;
      setWebContent(webContent);
      document.title = `${ContextService.SITE_NAME}:${webContent.title}`;
      setLoading(false);
    });
    window.scrollTo(0, 0);
  }, []);

  return (
    <div>
      <Loading show={loading} />
      {webContent.theme && (
        <ThemeCard
          backgroundImg={webContent.theme.image}
          opacity={0.9}
          title={webContent.theme.title as string}
          description={webContent.theme.description as string}
          minHeight={webContent.theme.height}
          caption={webContent.theme.caption}
          route={webContent.theme.route}
          routeText={webContent.theme.routeText}
        >
          <Container maxWidth="md">
            <h1 className="center secondary-light">
              {webContent.theme.h1?.title}
            </h1>
            {webContent.theme.h1?.children?.map((child) => {
              return (
                <h2 className="center secondary-light">{child.content}</h2>
              );
            })}
            <h2 className="center secondary-light">
              {webContent.theme.h2?.title}
            </h2>
            {webContent.theme.h2?.children?.map((child) => {
              return (
                <h3 className="center secondary-light">{child.content}</h3>
              );
            })}
          </Container>
        </ThemeCard>
      )}

      <Fade in={triggerPosition} timeout={4000}>
        <div ref={myRefPosition}>
          <Banner>
            <Grid
              container
              direction="column"
              justifyContent="flex-start"
              alignContent="flex-start"
            >
              <Grid
                container
                item
                xs={12}
                justifyContent="flex-start"
                alignItems="flex-start"
              >
                <h1>{webContent.h1?.title}</h1>
              </Grid>
              {webContent.h1?.children?.map((child) => {
                return (
                  <Grid
                    container
                    item
                    xs={12}
                    justifyContent="flex-start"
                    alignItems="flex-start"
                  >
                    <h2>{child.content}</h2>
                  </Grid>
                );
              })}
            </Grid>
          </Banner>

          <div className="section-white">
            <Container maxWidth="lg">
              <Grid
                container
                spacing={6}
                direction="row"
                justifyContent="center"
                alignItems="stretch"
                alignContent="center"
              >
                <Grid
                  container
                  item
                  xs={12}
                  sm={6}
                  md={4}
                  lg={3}
                  justifyContent="center"
                >
                  <IconCard
                    icon={
                      <ShareLocationIcon
                        color="secondary"
                        style={{ fontSize: 64 }}
                      />
                    }
                    title="Position"
                    description="Position objects in a 2-Dimision or 3-Dimision space with precision of ~10 CM"
                  />
                </Grid>
                <Grid
                  container
                  item
                  xs={12}
                  sm={6}
                  md={4}
                  lg={3}
                  justifyContent="center"
                >
                  <IconCard
                    icon={
                      <AssistantDirectionIcon
                        color="secondary"
                        style={{ fontSize: 64 }}
                      />
                    }
                    title="Track"
                    description="Track objects at real-time for their locations and/or moving paths"
                  />
                </Grid>

                <Grid
                  container
                  item
                  xs={12}
                  sm={6}
                  md={4}
                  lg={3}
                  justifyContent="center"
                >
                  <IconCard
                    icon={
                      <NotificationsActiveIcon
                        color="secondary"
                        style={{ fontSize: 64 }}
                      />
                    }
                    title="Alert/Guide"
                    description="Alert or guide at real-time for derailed or dangerous sitations"
                  />
                </Grid>

                <Grid container item xs={12} justifyContent="center">
                  <UMap
                    id="map-id-home-7688"
                    src="https://my-bsg-asset.s3.amazonaws.com/map/map_sample3.png"
                    refresh={1000}
                    markerSize={6}
                    step={30}
                    width="100%"
                    height="400px"
                  />
                </Grid>
              </Grid>
            </Container>
          </div>
        </div>
      </Fade>

      <Fade in={triggerVideo} timeout={4000}>
        <div ref={myRefVideo}>
          <Banner>
            <Grid
              container
              direction="column"
              justifyContent="flex-start"
              alignContent="flex-start"
            >
              <Grid
                container
                item
                xs={12}
                justifyContent="flex-start"
                alignItems="flex-start"
              >
                <h1>{webContent.h2?.title}</h1>
              </Grid>
              {webContent.h2?.children?.map((child) => {
                return (
                  <Grid
                    container
                    item
                    xs={12}
                    justifyContent="flex-start"
                    alignItems="flex-start"
                  >
                    <h2>{child.content}</h2>
                  </Grid>
                );
              })}
            </Grid>
          </Banner>
          <div className="section-white">
            <Container maxWidth="lg">
              <Grid
                container
                spacing={6}
                direction="row"
                justifyContent="center"
                alignItems="stretch"
                alignContent="center"
              >
                <Grid
                  container
                  item
                  xs={12}
                  sm={6}
                  md={4}
                  lg={3}
                  justifyContent="center"
                >
                  <IconCard
                    icon={
                      <SlowMotionVideoIcon
                        color="secondary"
                        style={{ fontSize: 64 }}
                      />
                    }
                    title="Analyze In-store Video Footage"
                    description="Analyze store video footage using machine learning (ML) technology and extract useful information about customers’ shopping behavior and habits."
                  />
                </Grid>
                <Grid
                  container
                  item
                  xs={12}
                  sm={6}
                  md={4}
                  lg={3}
                  justifyContent="center"
                >
                  <IconCard
                    icon={
                      <InsightsIcon
                        color="secondary"
                        style={{ fontSize: 64 }}
                      />
                    }
                    title="Explore Customer Insights"
                    description="Generate analytics dashboard and insight reports by correlating customer shopping behavior and product sales data"
                  />
                </Grid>

                <Grid
                  container
                  item
                  xs={12}
                  sm={6}
                  md={4}
                  lg={3}
                  justifyContent="center"
                >
                  <IconCard
                    icon={
                      <TouchAppIcon
                        color="secondary"
                        style={{ fontSize: 64 }}
                      />
                    }
                    title="Recommend Actions"
                    description="Optimize Store Layout
Create effective Marketing and Promotion
Increase Customer Loyalty"
                  />
                </Grid>
              </Grid>
            </Container>
          </div>

          <div className="section-dark">
            <Container maxWidth="lg">
              <Grid
                container
                spacing={6}
                direction="row"
                justifyContent="center"
              >
                <Grid
                  container
                  item
                  xs={12}
                  sm={10}
                  lg={6}
                  justifyContent="center"
                  alignContent="stretch"
                >
                  <YouTubeCard
                    video="3RMOvIe3WJY"
                    title="Sample 1"
                    description="UBQ Sample Video Processing"
                  />
                </Grid>
                <Grid
                  container
                  item
                  xs={12}
                  sm={10}
                  lg={6}
                  justifyContent="center"
                >
                  <YouTubeCard
                    video="X1ocDatscVA"
                    title="Sample 2"
                    description="UBQ Sample Video Processing"
                  />
                </Grid>
                <Grid
                  container
                  item
                  xs={12}
                  sm={10}
                  lg={6}
                  justifyContent="center"
                >
                  <YouTubeCard
                    video="Cflt2bD5JmM"
                    title="Sample 3"
                    description="UBQ Sample Video Processing"
                  />
                </Grid>
                <Grid
                  container
                  item
                  xs={12}
                  sm={10}
                  lg={6}
                  justifyContent="center"
                >
                  <YouTubeCard
                    video="QXzLa-kpiCo"
                    title="Sample 4"
                    description="UBQ Sample Video Processing"
                  />
                </Grid>
                <Grid
                  container
                  item
                  xs={12}
                  sm={10}
                  lg={6}
                  justifyContent="center"
                >
                  <YouTubeCard
                    video="7FfAqisEEKg"
                    title="Sample 5"
                    description="UBQ Sample Video Processing"
                  />
                </Grid>
              </Grid>
            </Container>
          </div>
        </div>
      </Fade>

      <div className="center">
        <ContactForm />
      </div>
    </div>
  );
};

export default HowWork;
